import { Bases } from "./_migrate";
import { ISpecialRule } from "./rules";
import { ISelectedUpgrade, IUpgradeGains, IUpgradeGainsItem, IUpgradeGainsWeapon } from "./upgrades";
import { ShipClass } from "./warfleets";

export enum UnitType {
  Default,
  NarrativeHero
}

export interface IUnit {
  id: string;
  armyId?: string;
  sortId?: number;
  name: string;
  genericName?: string;
  size: number;
  sizeSkirmish?: number;
  originalSize?: number; // Used in Triplify
  fullSize?: number;
  cost: number;
  quality: any;
  defense: any;
  upgrades: string[];
  weapons: IUpgradeGainsWeapon[];
  rules: ISpecialRule[];
  items: IUpgradeGainsItem[];
  disabledUpgradeSections?: string[];
  sync?: { unitId: string };
  valid?: boolean;
  hasBalanceInvalid?: boolean;
  hasCustomRule?: boolean;
  summoned?: boolean;
  bases: Bases;
  type?: UnitType;
  product?: UnitProductInfo;
}

export interface IWarfleetsUnit extends IUnit {
  class: ShipClass;
  evasion: number;
  move: number;
  cruise: number;
}

export type UnitProductInfo = {
  description?: string;
  avatarImageUrl?: string;
  imageUrls?: string[];
  storeLinksDigital?: { label: string; url: string }[];
  storeLinksPhysical?: { label: string; url: string }[];
};

export interface IUnitSelectionData {
  selectionId: string;
  customName?: string;
  selectedUpgrades: ISelectedUpgrade[];
  loadout: IUpgradeGains[];
  combined: boolean;
  joinToUnit?: string;
  xp: number;
  traits: string[]; // Trait names only
  notes: string;
}

export interface ISelectedUnit extends IUnit, IUnitSelectionData {}
export interface ISelectedWarfleetsUnit extends IWarfleetsUnit, IUnitSelectionData {}

export interface IFullUnit {
  unitSize: number;
  unitPoints: number;
  unitPointsAll: number;
  unit: ISelectedUnit;
  joined?: ISelectedUnit;
  hero: ISelectedUnit;
  hasJoined: boolean;
}
